import React, { useEffect, useState } from "react";
import { getFlows, getFlowLatestconfiguration } from "../utilities/genesysCloudUtils";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Flows({
  checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  opts,
  setOpts,
  filters,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [flows, setFlows] = useState([]);
  const [flowConfigurations, setFlowConfigurations] = useState({});

  useEffect(() => {
    generateFlows();
  }, [pageNumber, checkedDivisions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
  }, [checkedDivisions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setTabName("flows-tab");
    setOpts({
      name: "",
      type: {
        type: [],
        format: "checkbox",
        items: [
          {
            label: "Bot",
            value: "bot",
          },
          {
            label: "Common Module",
            value: "commonmodule",
          },
          {
            label: "Digital Bot",
            value: "digitalbot",
          },
          {
            label: "Email Send",
            value: "emailsend",
          },
          {
            label: "Inbound Call",
            value: "inboundcall",
          },
          {
            label: "Inbound Chat",
            value: "inboundchat",
          },
          {
            label: "Inbound Email",
            value: "inboundemail",
          },
          {
            label: "Inbound Short Message",
            value: "inboundshortmessage",
          },
          {
            label: "Outbound Call",
            value: "outboundcall",
          },
          {
            label: "In Queue Call",
            value: "inqueuecall",
          },
          {
            label: "In Queue Email",
            value: "inqueueemail",
          },
          {
            label: "In Queue Short Message",
            value: "inqueueshortmessage",
          },
          {
            label: "Speech",
            value: "speech",
          },
          {
            label: "Secure Call",
            value: "securecall",
          },
          {
            label: "Survey Invite",
            value: "surveyinvite",
          },
          {
            label: "Voice",
            value: "voice",
          },
          {
            label: "Voicemail",
            value: "voicemail",
          },
          {
            label: "Voice Survey",
            value: "voicesurvey",
          },
          {
            label: "Workflow",
            value: "workflow",
          },
          {
            label: "Workitem",
            value: "workitem",
          }
        ],
      },
    });
    setIsVisible({ divisions: true, object: true, applyButton: true })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    generateFlows();
    console.log("Generating Flows with filters:", filters);
  }, [filters.name, filters.type]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateFlows = (resetPage = false) => {
    const currentPage = resetPage ? 1 : pageNumber;

    if (resetPage && pageNumber !== 1) {
      setPageNumber(1);
    }

    let opts = {
      pageSize: 100, // Number | Page size
      pageNumber: currentPage,
      sortBy: "name", // String | Sort by
      sortOrder: "ASC", // String | Ascending or descending sort order
      name: "",
      divisionId: checkedDivisions, // [String] | List of divisionIds on which to filter.
    };

    if (filters.name && filters.name.length > 0) {
      opts.name = `*${filters.name}*`;
    }

    if (filters.type && filters.type.type && filters.type.type.length > 0) {
      console.log("Filters type:", filters.type);
      opts.type = filters.type.type;
    }

    getFlows(opts).then((data) => {
      setFlows(data.entities);
      setPageCount(data.pageCount);
    });
  };

  const allVisibleSelected = flows.length > 0 && flows.every((flow) => selectedExportRows[flow.id]);

  const loadFlowConfiguration = async (flowId) => {
    const configuration = await getFlowLatestconfiguration(flowId);

    setFlowConfigurations((currentConfigurations) => ({
      ...currentConfigurations,
      [flowId]: configuration,
    }));
  };

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      filteredExportAvailable={true}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: flows })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(flows, checked)}
      rowCount={flows.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Flows"
    >
      {flows ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th className="count-column">Count</th>
                <th>Flow Name</th>
                <th>Flow Type</th>
                <th>Languages</th>
                <th>Configuration</th>
                <th>Division</th>
                <th>Flow Id</th>
              </tr>
            </thead>
            <tbody>
              {flows.map((flow, index) => {
                return (
                  <tr key={flow.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${flow.name} for export`}
                        checked={Boolean(selectedExportRows[flow.id])}
                        onChange={(event) => onToggleExportRow(flow, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index count-column">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 100 + index + 1}
                    </th>
                    <td>{flow.name}</td>
                    <td>{flow.type}</td>
                    <td>{flow.publishedVersion?.supportedLanguages ? (
                      flow.publishedVersion.supportedLanguages.map((lang, index) => (
                        <p key={index}>
                          {lang.isDefault ? <strong>{lang.language}</strong> : lang.language}{" "}
                        </p>
                      ))
                    ) : ""}</td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => loadFlowConfiguration(flow.id)}
                        type="button"
                      >
                        Configuration
                      </button>
                      {/* <p>{flowConfigurations[flow.id]?.defaultLanguage || ""}</p> */}
                      {flowConfigurations[flow.id]?.manifest?.ttsEngine ? (
                        <>
                          <p>TTS Engines</p>
                          {flowConfigurations[flow.id]?.manifest?.ttsEngine.map((tts, index) => (
                            <p key={index}>
                              {tts.name}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      {flowConfigurations[flow.id]?.manifest?.ttsVoice ? (
                        <>
                          <p>TTS Voices</p>
                          {flowConfigurations[flow.id]?.manifest?.ttsVoice.map((tts, index) => (
                            <p key={index}>
                              {tts.name}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      {flowConfigurations[flow.id]?.errorHandling.audio.defaultAudio.config.AudioPlaybackOptions.text && (
                        <>
                          <p>Error Handling</p>
                          <p>{flowConfigurations[flow.id]?.errorHandling.audio.defaultAudio.config.AudioPlaybackOptions.text}</p>
                        </>
                      )}
                      {flowConfigurations[flow.id]?.speechRecCompanyDirectory.text && (
                        <>
                          <p>Company Directory</p>
                          <p>{flowConfigurations[flow.id]?.speechRecCompanyDirectory.text}</p>
                        </>
                      )}
                      {flowConfigurations[flow.id]?.suppressRecording.text && (
                        <>
                          <p>Suppress Recording</p>
                          <p>{flowConfigurations[flow.id]?.suppressRecording.text}</p>
                        </>
                      )}
                      {flowConfigurations[flow.id]?.manifest?.dataAction ? (
                        <>
                          <p>Data Actions</p>
                          {flowConfigurations[flow.id]?.manifest?.dataAction.map((action, index) => (
                            <p key={index}>
                              {action.name} - {action.id}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      {flowConfigurations[flow.id]?.manifest?.dataTable ? (
                        <>
                          <p>Data Tables</p>
                          {flowConfigurations[flow.id]?.manifest?.dataTable.map((table, index) => (
                            <p key={index}>
                              {table.name} - {table.id}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      {flowConfigurations[flow.id]?.manifest?.emergencyGroup ? (
                        <>
                          <p>Emergency Groups</p>
                          {flowConfigurations[flow.id]?.manifest?.emergencyGroup.map((group, index) => (
                            <p key={index}>
                              {group.name} - {group.id}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      {flowConfigurations[flow.id]?.manifest?.scheduleGroup ? (
                        <>
                          <p>Schedule Groups</p>
                          {flowConfigurations[flow.id]?.manifest?.scheduleGroup.map((schedule, index) => (
                            <p key={index}>
                              {schedule.name} - {schedule.id}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      {flowConfigurations[flow.id]?.manifest?.voiceSurveyFlow ? (
                        <>
                          <p>Voice Survey Flows</p>
                          {flowConfigurations[flow.id]?.manifest?.voiceSurveyFlow.map((survey, index) => (
                            <p key={index}>
                              {survey.name} - {survey.id}
                            </p>
                          ))}
                        </>
                      ) : ""}
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </td>
                    <td>{flow.division.name}</td>
                    <td className="centered-text"><kbd className="kbd">{flow.id}</kbd></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
